import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, ofType } from '@ngrx/effects';
import { Subject, Observable, of } from 'rxjs';
import { tap, takeUntil, filter, map, take } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import * as fromAuthStore from '@apps/auth/store';
import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

@Component({
    selector: 'aa-header-subscriptions',
    templateUrl: './header-subscriptions.component.html',
    styleUrls: [
        './header-subscriptions.component.scss'
    ],
    standalone: false
})
export class HeaderSubscriptionsComponent implements OnInit, OnDestroy
{
    private destroyator = new Subject();
    public language: string;
    public isAdmin: Observable<boolean> = of(false);
    public isAuthorized: Observable<boolean> = of(false);

    constructor (
        private actions: Actions,
        private store: Store<IAuroraState>,
        private routerStore: Store<any>,
        private router: Router
    )
    {
    }

    ngOnInit ()
    {
        this.actions
            .pipe(
                ofType(fromAuthStore.AuthProfileStoreActions.AuthProfileLanguageSet),
                tap((action) =>
                    this.language = action.language
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();

        this.isAuthorized = this.store
            .select(fromAuthStore.getBackAuthorization);

        this.isAdmin = this.routerStore
            .pipe(
                select(fromRootStore.selectUrl),
                filter((url: string) => url && 0 !== url.length),
                map((url: string) => url.includes('/admin'))
            );
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onAdminClick ()
    {
        this.store.select(fromRootStore.getLastAdminUrl)
            .pipe(
                take(1),
                tap((url: string) =>
                    this.router.navigateByUrl(decodeURIComponent(url))
                )
            )
            .subscribe();
    }

    onCustomerClick ()
    {
        this.store.select(fromRootStore.getLastCustomerUrl)
            .pipe(
                take(1),
                tap((url: string) =>
                    this.router.navigateByUrl(decodeURIComponent(url))
                )
            )
            .subscribe();
    }
}
